function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var defaults = {
  friction: 0.92
};
export var Sync = /*#__PURE__*/function () {
  function Sync(carousel) {
    _classCallCheck(this, Sync);

    this.carousel = carousel;
    this.selectedIndex = null;
    this.friction = 0;
    this.onNavReady = this.onNavReady.bind(this);
    this.onNavClick = this.onNavClick.bind(this);
    this.onNavCreateSlide = this.onNavCreateSlide.bind(this);
    this.onTargetChange = this.onTargetChange.bind(this);
  }
  /**
   * Make this one as main carousel and selected carousel as navigation
   * @param {Object} nav Carousel
   */


  _createClass(Sync, [{
    key: "addAsTargetFor",
    value: function addAsTargetFor(nav) {
      this.target = this.carousel;
      this.nav = nav;
      this.attachEvents();
    }
    /**
     * Make this one as navigation carousel for selected carousel
     * @param {Object} target
     */

  }, {
    key: "addAsNavFor",
    value: function addAsNavFor(target) {
      this.target = target;
      this.nav = this.carousel;
      this.attachEvents();
    }
    /**
     * Attach event listeners on both carousels
     */

  }, {
    key: "attachEvents",
    value: function attachEvents() {
      this.nav.options.initialSlide = this.target.options.initialPage;
      this.nav.on("ready", this.onNavReady);
      this.nav.on("createSlide", this.onNavCreateSlide);
      this.nav.on("Panzoom.click", this.onNavClick);
      this.target.on("change", this.onTargetChange);
      this.target.on("Panzoom.afterUpdate", this.onTargetChange);
    }
    /**
     * Process main carousel `ready` event; bind events and set initial page
     */

  }, {
    key: "onNavReady",
    value: function onNavReady() {
      this.onTargetChange(true);
    }
    /**
     * Process main carousel `click` event
     * @param {Object} panzoom
     * @param {Object} event
     */

  }, {
    key: "onNavClick",
    value: function onNavClick(carousel, panzoom, event) {
      var clickedNavSlide = event.target.closest(".carousel__slide");

      if (!clickedNavSlide) {
        return;
      }

      event.stopPropagation();
      var selectedNavIndex = parseInt(clickedNavSlide.dataset.index, 10);
      var selectedSyncPage = this.target.findPageForSlide(selectedNavIndex);

      if (this.target.page !== selectedSyncPage) {
        this.target.slideTo(selectedSyncPage, {
          friction: this.friction
        });
      }

      this.markSelectedSlide(selectedNavIndex);
    }
    /**
     * Process main carousel `createSlide` event
     * @param {Object} carousel
     * @param {Object} slide
     */

  }, {
    key: "onNavCreateSlide",
    value: function onNavCreateSlide(carousel, slide) {
      if (slide.index === this.selectedIndex) {
        this.markSelectedSlide(slide.index);
      }
    }
    /**
     * Process target carousel `change` event
     * @param {Object} target
     */

  }, {
    key: "onTargetChange",
    value: function onTargetChange() {
      var targetIndex = this.target.pages[this.target.page].indexes[0];
      var selectedNavPage = this.nav.findPageForSlide(targetIndex);
      this.nav.slideTo(selectedNavPage);
      this.markSelectedSlide(targetIndex);
    }
    /**
     * Toggle classname for slides that marks currently selected slides
     * @param {Number} selectedIndex
     */

  }, {
    key: "markSelectedSlide",
    value: function markSelectedSlide(selectedIndex) {
      this.selectedIndex = selectedIndex;

      _toConsumableArray(this.nav.slides).filter(function (slide) {
        return slide.$el && slide.$el.classList.remove("is-nav-selected");
      });

      var slide = this.nav.slides[selectedIndex];
      if (slide && slide.$el) slide.$el.classList.add("is-nav-selected");
    }
  }, {
    key: "attach",
    value: function attach(carousel) {
      var sync = carousel.options.Sync;

      if (!sync.target && !sync.nav) {
        return;
      }

      if (sync.target) {
        this.addAsNavFor(sync.target);
      } else if (sync.nav) {
        this.addAsTargetFor(sync.nav);
      }

      this.friction = sync.friction;
    }
  }, {
    key: "detach",
    value: function detach() {
      if (this.nav) {
        this.nav.off("ready", this.onNavReady);
        this.nav.off("Panzoom.click", this.onNavClick);
        this.nav.off("createSlide", this.onNavCreateSlide);
      }

      if (this.target) {
        this.target.off("Panzoom.afterUpdate", this.onTargetChange);
        this.target.off("change", this.onTargetChange);
      }
    }
  }]);

  return Sync;
}(); // Expose defaults

Sync.defaults = defaults;